import React, { useRef, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAppStore } from '../store/appStore';

const IntroVideo = () => {
  const videoRef = useRef(null);
  const setShowIntroVideo = useAppStore((state) => state.setShowIntroVideo);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      // 添加视频加载事件监听
      video.addEventListener('loadeddata', () => {
        console.log('Video loaded, duration:', video.duration);
        setVideoLoaded(true);
      });

      // 添加播放进度监听（调试用）
      video.addEventListener('timeupdate', () => {
        // 可选：打印播放进度
        // console.log('Current time:', video.currentTime, 'Duration:', video.duration);
      });

      // 尝试自动播放视频
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.log('Auto-play was prevented:', error);
          // 如果自动播放被阻止，显示播放按钮或提示用户点击
        });
      }
    }
  }, []);

  const handleVideoEnd = () => {
    console.log('Video ended at:', new Date().toISOString());
    console.log('Calling setShowIntroVideo(false)...');
    // 视频播放完成后，立即隐藏视频组件
    setShowIntroVideo(false);
    console.log('setShowIntroVideo(false) called');
  };

  return (
    <motion.div
      className="fixed inset-0 z-50 bg-black flex items-center justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      onAnimationComplete={() => {
        console.log('IntroVideo exit animation completed at:', new Date().toISOString());
      }}
    >
      {!videoLoaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-black z-10">
          <div className="text-center">
            <div className="w-16 h-16 border-4 border-purple-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-white text-lg">Loading intro video...</p>
          </div>
        </div>
      )}
      <video
        ref={videoRef}
        className="w-full h-full object-cover"
        autoPlay
        muted
        playsInline
        onEnded={handleVideoEnd}
      >
        <source src="/open_video.mp4" type="video/mp4" />
        您的浏览器不支持视频播放。
      </video>
    </motion.div>
  );
};

export default IntroVideo;
